import { GrowthDashboardTopBarActions, MarketIntelligenceView } from '@elva/ui';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useMarketIntelligence } from '../hooks/useMarket';

export function MarketPage() {
  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } =
    useMarketIntelligence();

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <MarketIntelligenceView {...viewProps({ data, loading: isFetching })} />
    </AsyncBoundary>
  );
}
